import { chapter } from '~/types/terms.content.type'

export const chapterList: chapter[] = [
  {
    title: 'Chapter 1: General Provisions',
    sections: [
      {
        title: 'Article 1: Purpose',
        subItems: [
          {
            title: 'These terms and conditions aim to define the rights, obligations, and responsibilities between CrossAngle Pte. Ltd. (hereinafter referred to as the "Company") and Users regarding the use of the online internet service known as the MapleStory Universe Explorer (hereinafter referred to as "the Service") provided by the Company.'
          }
        ],
        type: 'span'
      },
      {
        title: 'Article 2: Effectiveness and Amendment of the Terms and Conditions',
        subItems: [
          {
            title: 'The Company provides the Service to Users on the condition that Users accept the terms outlined in these Terms of Service, which govern the provision of the Service and the User\'s usage thereof.'
          },
          {
            title: 'The Company reserves the right to modify these Terms of Service without prior notice, and any modifications shall become effective immediately upon announcement through electronic means.',
          }
        ],
        type: 'ul'
      },
      {
        title: 'Article 3: Supplementary Provisions',
        subItems: [
          {
            title: 'Matters not explicitly addressed in these terms and conditions shall be subject to relevant laws and regulations, including but not limited to the Framework Act on Telecommunications, the Telecommunications Business Act, the Regulations of the Korea Internet Safety Commission, the Code of Ethics for Information and Communication, the Copyright Act, and other related legislation.'
          }
        ],
        type: 'span'
      },
      {
        title: 'Article 4: Definitions',
        subItems: [
          {
            title: 'The definitions of terms used in these terms and conditions are as follows:',
            contents: [
              '"Company" refers to the entity providing the MapleStory Universe Explorer service based on blockchain data.',
              '"User" refers to any individual utilizing the Company\'s service, including both members and non-members.',
              '"Member" refers to an individual who has completed membership registration through wallet integration or procedures provided by the Service and can access the Company\'s services continuously.',
              '"Non-member" refers to an individual using the Company\'s service without registering as a member.'
            ]
          },
          {
            title: 'Unless otherwise specified in Article 1 of this section, the definitions of terms used in these terms and conditions shall conform to relevant laws and regulations. Terms not defined herein shall be interpreted according to common industry standards.'
          }
        ],
        type: 'ol'
      },
    ],
  },
  {
    title: 'Chapter 2: Service Provision and Utilization',
    sections: [
      {
        title: 'Article 5: Formation of Service Agreement',
        subItems: [
          {
            title: 'The service agreement is established when the User completes registration by providing the required information in the membership application form provided by the Service, and the Company approves such registration.'
          },
          {
            title: 'The Service reserves the right to cancel membership under the following circumstances:',
            contents: [
              'If the application is submitted using another person\'s identity.',
              'If false information is provided in the application form or if the application is submitted fraudulently.',
              'If the application is made with the intent to disrupt social order or morality.',
              'If the user interferes with others\' use of the Service or engages in activities such as misappropriating their information.',
              'If the user violates laws or these terms and conditions through the use of the Service.',
              'If the user fails to meet the requirements specified by the Service for application.'
            ],
          },
          {
            title: 'The Service may postpone the establishment of the service agreement until the following circumstances are resolved:',
            contents: [
              'Insufficient capacity related to the service.',
              'Technical issues.'
            ]
          },
          {
            title: 'The services provided by the Company encompass all services provided through self-development or agreements with other businesses. The Company reserves the right to modify the content of these services after notifying Users.'
          }
        ],
        type: 'ul'
      },
      {
        title: 'Article 6: Consent Regarding Use of Member Information',
        subItems: [
          {
            title: 'The Company does not collect personal information from Users and is dedicated to preserving their privacy. However, service usage records and statistical data may be collected and anonymized for analysis and service enhancement purposes.'
          }
        ],
        type: 'span'
      },
      {
        title: 'Article 7: Service Operating Hours',
        subItems: [
          {
            title: 'The Service provided by the Company operates on a 24/7 basis, 365 days a year.',
          },
          {
            title: 'The service hours specified in clause 1 may be subject to exceptions for scheduled maintenance or unforeseen incidents.',
          }
        ],
        type: 'ol'
      },
      {
        title: 'Article 8: Suspension of Service and Storage and Use of Information',
        subItems: [
          {
            title: 'The Company shall not be held liable for any loss of data, communication data, or other transmitted data stored in or transmitted through the Service due to national emergencies, power outages, service equipment failures beyond the scope of Service management, or other force majeure events. This includes instances where data could not be stored, was deleted, or was not transmitted, as well as any loss of communication data.'
          },
          {
            title: 'If temporary suspension of the Service becomes necessary due to difficulties in providing normal services, the Company may suspend the Service after providing one week\'s advance notice to Users. The Company shall not be responsible for users\' unawareness of the notification during this period. In exceptional circumstances, the prior notification period may be shortened or omitted. Furthermore, the Company shall not be liable for any loss of data, communication data, or other transmitted data stored in or transmitted through the Service due to such suspension, including instances where data could not be stored, was deleted, was not transmitted, or any loss of communication data.'
          },
          {
            title: 'Permanent discontinuation of the Service shall be determined in accordance with clause 2. However, in this case, the prior notification period shall be one month.',
          },
          {
            title: 'The Service may temporarily modify, change, or suspend the Service after providing prior notification and shall not be liable for any responsibility to Users or third parties in this regard.',
          },
          {
            title: 'If a User violates the terms of this agreement, the Service reserves the right to restrict or suspend the user\'s access to the Service without prior notice.',
          },
        ],
        type: 'ol'
      },
      {
        title: 'Article 9: Service Modification and Termination',
        subItems: [
          {
            title: 'The Service shall not be held responsible for any damages incurred by Users due to materials obtained through the Service. Moreover, the Service disclaims liability for the reliability, accuracy, or content of information, data, or facts acquired by users through the Service.'
          },
          {
            title: 'The Service shall not be liable for damages resulting from intentional or negligent actions by Users in connection with service usage.'
          }
        ],
        type: 'ul'
      },
      {
        title: 'Article 10: Provision of Information and Publication of Promotional Materials',
        subItems: [
          {
            title: 'The Company may provide various information to Users through methods such as posting on the Website in operating the Service.',
          },
          {
            title: 'The Company may publish advertisements and promotional materials deemed appropriate for the Service or related to the Service.',
          }
        ],
        type: 'ul'
      },
      {
        title: 'Article 11: Intellectual Property Rights',
        subItems: [
          {
            title: 'The copyrights and intellectual property rights of all content and materials provided by the Company belong to the Company or the copyright holder providing the content.',
          },
          {
            title: 'Users may not engage in unauthorized reproduction, distribution, modification, publication, sending, sale, rental, or any other act of granting third-party usage without prior approval from the Company when using the services provided by the Company.'
          },
          {
            title: 'The Service reserves the right to edit or delete the provided services without prior notice.'
          },
          {
            title: 'Users shall bear all civil and criminal liabilities that arise from infringement of the Company\'s copyrights.',
          },
        ],
        type: 'ul'
      },
      {
        title: 'Article 12: Code of Conduct for Users and Restriction on Service Use',
        subItems: [
          {
            title: 'If it is found or reasonably suspected that the information provided by blockchain operators is false, the Service may partially or entirely suspend the use of the Service, and shall not be liable for any resulting disadvantages'
          },
          {
            title: 'Users shall bear all responsibility for all forms of information posted, sent, or received through the Service and all forms of information posted, sent, or received by other means such as E-mail, and the Company shall not be liable.'
          },
          {
            title: 'The Company does not guarantee the accuracy, completeness, or quality of the content provided by blockchain operators. Therefore, the Service shall not be liable for any loss or damage incurred by Users using such content.'
          },
          {
            title: 'Users agree not to engage in the following actions when using the Service:',
            contents: [
              'Using the service for illegal purposes',
              'Unauthorized access (data access) to the Service or using robots, spiders, crawlers, scrappers, or other automated means or interfaces not provided by the Service to extract data',
              'Disguising the source of content sent through the Service',
              'Posting, publishing, or sending content that cannot be used under law or contract via E-mail or other methods',
              'Posting, publishing, or sending content that infringes on others\' patents, trademarks, trade secrets, copyrights, or other intellectual property rights via E-mail or other methods',
              'Posting, publishing, or sending advertisements, promotions, junk mail, spam, chain letters, pyramid schemes, or any other form of solicitation unauthorized by the Service via E-mail or other methods',
              'Collecting or storing other Users’ information',
            ]
          },
          {
            title: 'Acts that may interfere with or potentially interfere with the operation of the Service.',
          },
          {
            title: 'If it is determined that a User has violated these terms, the Site may delete all information related to the Service without the User\'s consent.',
          },
          {
            title: 'If a User who is restricted from using the Service under the provisions of Paragraph 1 objects to the measures taken, the User may file an objection; however, the Company shall not be responsible for the User’s deleted data  upon service restriction. If a User violates these terms of the Agreement, the Company may temporarily or permanently restrict the User\'s access to the service without prior warning.'
          }
        ]
        ,
        type: 'ol'
      }
    ]
  },
  {
    title: 'Chapter 3: Obligations and Responsibilities',
    sections: [
      {
        title: 'Article 13: Obligations of the Service',
        subItems: [
          {
            title: 'The Service provides Users with the following services:',
            contents: [
              'Blockchain data-based services',
              'Other services designated by the Company',
            ]
          },
          {
            title: 'The Company shall not engage in any acts prohibited by law and this Agreement or contrary to public order and morals, and has duty to provide the Service continuously and reliably.'
          },
          {
            title: 'The Site must have security systems in place to ensure that Users can safely use the Site\'s services.'
          },
          {
            title: 'The Site shall not be responsible for service disruptions caused by reasons attributable to the User.'
          },
        ],
        type: 'ul'
      },
      {
        title: 'Article 14: Obligations of the User',
        subItems: [
          {
            title: 'Users may not engage in any for-profit activities by using the Service without the prior approval of the Company.'
          },
          {
            title: 'Users may not copy, reproduce, alter, translate, publish, broadcast, or otherwise use the information obtained through the use of the Service without acknowledging the source, or provide it to others.'
          },
          {
            title: 'Users shall not engage in the following acts related to the use of the Service:',
            contents: [
              'Acts aimed at or otherwise related to criminal activities',
              'Acts that violate public morals or social order',
              'Acts that defame or insult others\' honor',
              'Acts that infringe on others\' intellectual property rights',
              'Hacking or spreading computer viruses',
              'Continuously transmitting specific content, such as advertising information, contrary to the intentions of others',
              'Any acts that may or does disrupt the safe operation of the Service',
              'Altering information posted on the Site',
            ],
          },
        ],
        type: 'ul'
      },
    ],
  },
  {
    title: 'Chapter 4: Miscellaneous',
    sections: [
      {
        title: 'Article 15: Ownership of the Service',
        subItems: [
          {
            title: 'Intellectual property rights and other rights related to the services provided by the Service, including software, images, marks, logos, designs, service names, information, and trademarks, belong to the Company.'
          },
          {
            title: 'Except with explicit approval, Users may not engage in any act of altering, renting, lending, selling, distributing, producing, transferring, sublicensing, creating a security interest, or engaging in commercial use of any or all of the properties specified in Paragraph 1, nor may they allow third parties to engage in such acts. '
          }
        ],
        type: 'ul'
      },
      {
        title: 'Article 16: Prohibition of Assignment',
        subItems: [
          {
            title: 'Users may not assign or transfer their rights to use the Service or any other status under the service contract to a third party, nor may they provide it as collateral.'
          }
        ],
        type: 'ul'
      },
      {
        title: 'Article 17: Indemnification',
        subItems: [
          {
            title: 'The Company shall not be liable for any damages incurred for Users in connection with the use of the free services provided.'
          }
        ],
        type: 'ul'
      },
      {
        title: 'Article 18: Disclaimer',
        subItems: [
          {
            title: 'The Company has no obligation to ensure or represent any opinions or information expressed in the Service and shall neither approve nor oppose nor alter opinions expressed by Users or third parties. The Service shall not be responsible for any benefits or damages incurred by Users relying on the information contained in the Service.'
          },
          {
            title: 'The Service shall not be liable for any transactions, whether commercial or monetary, between Users or between Users and third parties through the Service, nor shall it be responsible for any expected benefits arising from the use of the Service.'
          },
        ],
        type: 'ul'
      },
      {
        title: 'Article 19: Jurisdiction',
        subItems: [
          {
            title: 'In the event of any dispute arising in connection with the use of this Service, the Seoul Central District Court shall be the exclusive jurisdictional court.'
          },
        ],
        type: 'ul'
      },
      {
        title: 'Supplementary Provision',
        subItems: [
          {
            title: '[Effective Date] This Agreement shall come into effect on August 30, 2023.'
          },
        ],
        type: 'span'
      }
    ],
  }
]